import { Element } from "@xmpp/xml"

export const NAVIGATOR_ATTACHMENT_COMMAND_NODE = "get_navigator_attachment"

export type NavigatorAttachmentLink = {
  attachmentId: string
  url: string
  fileName?: string
  contentType?: string
  sizeBytes?: number
}

const COMMAND_NS = "http://jabber.org/protocol/commands"
const JSON_NS = "urn:xmpp:json:0"

const isAttachmentLink = (value: unknown): value is NavigatorAttachmentLink => {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof (value as NavigatorAttachmentLink).url === "string"
  )
}

const NavigatorAttachmentParser = {
  parse(stanza: Element): NavigatorAttachmentLink | undefined {
    const command = stanza.getChild("command", COMMAND_NS)
    const jsonElement = command?.getChild("json", JSON_NS)
    if (!jsonElement) return undefined

    try {
      const parsed = JSON.parse(jsonElement.text())
      return isAttachmentLink(parsed) ? parsed : undefined
    } catch {
      return undefined
    }
  },
}

export default NavigatorAttachmentParser
